// extracted by mini-css-extract-plugin
export var footerLogos = "footer-module--footerLogos--OJk+r";